// export class Server {

// 	public array: any[];
// 	public bestUrl: string;
// 	public downloadUrl: string;
// 	public downloadSize: string;
// 	public uploadUrl: string;

// 	constructor(){}
// }

export class Server {

    public base: string;
    public downloadSize: string;
    public downloadSizeSmall: string;
    public downloadUrl: string;
    public downloadTestUrl: string;
    public id: number;
    public latitude: number;
    public longitude: number;
    public name: string;
    public uploadSize: number;
    public uploadUrl: string;
    public objectId: string;
    public ip: string;
    public distance: number;
    public country: string;
    public cc: string;
    public city: string;
    public https_functional: number;
    public location: any;

    constructor() {
    }
}
